module.exports = __webpack_public_path__ + "static/img/celoscope-24.8ee40e6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/celoscopepic/celoscope-24.jpg
// module id = pTFd
// module chunks = 51